import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import SmoothCollapse from "react-smooth-collapse";

const matchesPath = (pathname, path) =>
  !!path &&
  (path === "/"
    ? pathname === "/"
    : pathname === path || pathname.startsWith(path + "/"));

const DropdownMenuItem = ({
  icon,
  text,
  href,
  subPaths = [],
  setRefresh,
  onItemClick,
  children,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [manuallyOpen, setManuallyOpen] = useState(false);

  const routeActive =
    matchesPath(location.pathname, href) ||
    subPaths.some((path) => matchesPath(location.pathname, path));

  const expanded = manuallyOpen || routeActive;

  const handleClick = (e) => {
    e.preventDefault();
    onItemClick?.();
    if (href) {
      navigate(href);
      document.getElementById("sidebar")?.classList.remove("active");
      setRefresh?.((r) => !r);
    }
    setManuallyOpen((o) => !o);
  };

  return (
    <>
      <li className={expanded ? "dropdown-expanded" : ""}>
        <a href={href || "/#"} onClick={handleClick}>
          <FontAwesomeIcon icon={icon} />
          <span className="links_name">{text}</span>
          <FontAwesomeIcon icon={faChevronDown} className="chevron-icon" />
        </a>
      </li>
      <SmoothCollapse expanded={expanded} className="sub-menu">
        <ul>{children}</ul>
      </SmoothCollapse>
    </>
  );
};

export default DropdownMenuItem;
